import {connect} from "react-redux";
import ParkingAccount from "./Save";
import {bindActionCreators} from "redux";
import {getFilter} from "../../../../service/Account/action";
import {getCityByStateId} from "../../../../service/Account/action";
import {accountList} from "../../../../service/Parking/action";
import {
    locationPinCode,
    locationCity,
    locationZone,
    locationArea,
    stateAndRegion
} from "../../../../service/locations/action";
import {accountById} from "../../../../service/Valet/action";
import {saveAccount} from "../../../../service/Parking/action";

const mapStateToProps = (state) => ({
    pincodeData: state.locationReducer.pincodeData,
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
    accountDetailsByIdData: state.Valet.accountById,
    saveDetails: state.Parking.saveAccountDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountList,
            getFilter,
            getCityByStateId,
            locationCity,
            locationPinCode,
            locationZone,
            locationArea,
            stateAndRegion,
            accountById,
            saveAccount
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ParkingAccount);
